import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { LOCATION_INITIALIZED } from '@angular/common';
import { inject } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  apiEndPoint: string | undefined;
  imagePreviewUrl: string | undefined;
  productVersion: string | undefined; 
  secretKey:string | undefined;
  // AES-256-CBC encryption configuration (hex strings)
  cryptoSecretKey?: string; // 64 hex chars (32 bytes)
  cryptoIv?: string;        // 32 hex chars (16 bytes)
  idleTimeoutDuration: number | undefined;
  timeoutWarningDuration: number | undefined;
}
// preInitServiceFactory.ts
export function preInitServiceFactory(): () => Promise<void> {
  return () => {
    const locationInitialized = inject(LOCATION_INITIALIZED, { optional: true }) ?? Promise.resolve();
    const preInitService = inject(PreInitService);

    return locationInitialized.then(() =>
      preInitService.onInit().then(() => void 0) // Convert boolean to void
    );
  };
}



// export function preInitServiceFactory(
//   initService: PreInitService,
//   injector: Injector
// ) {
//   return () =>
//     new Promise((resolve) =>
//       injector
//         .get(LOCATION_INITIALIZED, Promise.resolve(undefined))
//         .then(() => resolve(initService.onInit()))
//     );
// }

@Injectable({
  providedIn: 'root',
})
export class AppSettingsService {
  settings: Observable<Readonly<ConfigService>>;

  private settingsSource: BehaviorSubject<ConfigService> =
    new BehaviorSubject<ConfigService>(new ConfigService());

  constructor() {
    this.settings = this.settingsSource.asObservable();
  }

  setSettings(settings: Partial<ConfigService>) {
    const updatedConfig = { ...this.settingsSource.value, ...settings };
    this.settingsSource.next(updatedConfig);
  }

  getSettings(): Readonly<ConfigService> {
    return this.settingsSource.value;
  }
}
@Injectable({ providedIn: 'root' })
export class PreInitService {
  constructor(
    private appSettingsService: AppSettingsService
  ) {}
 
  async onInit(): Promise<void> {
    // Load settings synchronously from Angular environment
    const config: Partial<ConfigService> = {
      apiEndPoint: environment.apiEndPoint,
      imagePreviewUrl: environment.imagePreviewUrl,
      productVersion: environment.productVersion,
      secretKey: environment.secretKey,
      cryptoSecretKey: environment.cryptoSecretKey,
      cryptoIv: environment.cryptoIv
    };
    this.appSettingsService.setSettings(config);
  }
}